import { render, staticRenderFns } from "./OrdemServicoFornecedor.vue?vue&type=template&id=1543cb4a&scoped=true&"
import script from "./OrdemServicoFornecedor.vue?vue&type=script&lang=js&"
export * from "./OrdemServicoFornecedor.vue?vue&type=script&lang=js&"
import style0 from "./OrdemServicoFornecedor.vue?vue&type=style&index=0&id=1543cb4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1543cb4a",
  null
  
)

export default component.exports